module.exports = __webpack_public_path__ + "img/icon-info.bbeabfb2.svg";